import { render, staticRenderFns } from "./number.vue?vue&type=template&id=37529fd4&scoped=true&"
import script from "./number.vue?vue&type=script&lang=ts&"
export * from "./number.vue?vue&type=script&lang=ts&"
import style0 from "./number.vue?vue&type=style&index=0&id=37529fd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37529fd4",
  null
  
)

export default component.exports